(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("g8iNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbebfa659ba3f994$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $bbebfa659ba3f994$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function BackToTop(param) {
        var el = param.el;
        (0, $J7ygF._)(this, BackToTop);
        this.el = el;
        this.button = this.el.querySelector("button");
        this.init();
    }
    (0, $hvJJn._)(BackToTop, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.button) this.button.addEventListener("click", function(e) {
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                });
                if (this.el.dataset.scroll === "true") window.addEventListener("scroll", function() {
                    if (window.scrollY > 300) _this.el.classList.add("active");
                    else _this.el.classList.remove("active");
                }, {
                    passive: true
                });
            }
        }
    ]);
    return BackToTop;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=BackToTop.90efe43e.js.map
